// src/views/words-lists/ShareWordsListModal/ShareWordsListModal.tsx
import React, { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TbList } from 'react-icons/tb';
import { refreshWordsListPage } from '../../slice/actions';
import classes from './ShareWordsListModal.module.less';
import AppModal from '../../../../components/AppModal';
import ListOfStudentsInModal from './ListOfStudentsInModal';

// ✅ ZMIEŃ TEN TYP:
type ShareWordsListModalProps = {
  wordsList: {
    id: number;
    name: string;
    sharedStudentIds: number[];
  };
  hideModal: () => void;
};

const ShareWordsListModal: FC<ShareWordsListModalProps> = ({
  wordsList,
  hideModal,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Każda zmiana udostępnień zapisuje się od razu przy kliknięciu i ma własny komunikat. Okno zapamiętuje tylko,
  // że coś się zmieniło — wtedy po zamknięciu odświeża listy
  const [hasChanges, setHasChanges] = useState(false);

  const onCancel = useCallback(() => {
    if (hasChanges) {
      dispatch(refreshWordsListPage());
    }

    hideModal();
  }, [dispatch, hideModal, hasChanges]);

  const handleShareUpdate = useCallback(() => {
    setHasChanges(true);
  }, []);

  return wordsList ? (
    <AppModal
      title={t('words-list:share.title')}
      visible={Boolean(wordsList)}
      onCancel={onCancel}
      wide
    >
      {/* Lista jak uczeń w oknie „Aktywność”: ikona w morskim kwadracie i nazwa */}
      <div className={classes.listHeader}>
        <span className={classes.listIcon}><TbList /></span>
        <span className={classes.listName} title={wordsList.name}>{wordsList.name}</span>
      </div>

      <ListOfStudentsInModal
        wordsList={wordsList}
        onShareUpdate={handleShareUpdate}
      />
    </AppModal>
  ) : null;
};

export default ShareWordsListModal;
